<template lang="pug">
    div.copyLink(@click.prevent.stop="copyLink")
        v-icon content_copy
</template>

<script>
    import VueTypes from 'vue-types';
    import Handler from '~services/Handler';

    export default {
        props: {
            link: VueTypes.string.def('')
        },
        methods: {
            copyLink() {
                navigator.clipboard.writeText(encodeURI(this.link)).then(
                    function() {
                        Handler.handleResponse(
                            { ok: true },
                            'Copying theme link to clipboard was successful!'
                        );
                    },
                    function() {
                        Handler.handleResponse(
                            { ok: false },
                            'Could not copy text'
                        );
                    }
                );
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl"

    .copyLink
        position: absolute
        top: 10px
        left: 10px
        z-index: 5
        padding: 4px
        background-color: $theme.primary
        border-radius: 50%
        width: 24px
        height: 24px
        text-align: center

        i
            color: #fff
            font-size: 14px
</style>
